<cx-carousel [title]="title$ | async" [items]="items$ | async" [template]="carouselItem">
</cx-carousel>

<ng-template #carouselItem let-item="item">
  <div class="carousel-item-container">
    <app-efa-cart-item-add-to-wish-list [product]="item" [orderInfoRefId]="0" [IsAddedFromSearchPage]="true">
    </app-efa-cart-item-add-to-wish-list>
    <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl"
      [queryParams]="{ source: pdpCallSource }">
      @if (item.productCampaign) {
        <app-product-badge [content]="item.productCampaign?.text"
          [style.backgroundColor]="item.productCampaign?.backgroundColor" [style.color]="item.productCampaign?.textColor"
        class="product-references-product-badge"></app-product-badge>
      }
      <cx-media class="cx-product-image" [container]="item.images?.PRIMARY" format="product"></cx-media>
      <div class="pl-2">
        <h3 class="product-name">
          {{ item.name }}
        </h3>
        <p class="manufacturerAID">
          {{ item.manufacturerAID }}
        </p>
      </div>
    </a>
    <div class="price">
      @if (item.price?.value > 0) {
        <span>
          {{ item.price.formattedValue }}
        </span>
      }
    </div>
    <div class="carousel-item-container-bottom-content">
      <app-efa-add-to-cart [isCalledFromPDP]="true" [product]="item" [showQuantityHint]="false"
        [listPricePerUnit]="item.price" [customerPricePerUnit]="item.price" [priceAvailable]="item.price?.value > 0">

      </app-efa-add-to-cart>
    </div>
  </div>

</ng-template>